import { TThunkAction } from '../../types/redux';
import { getFiltersFailure, getFiltersRequest, getFiltersSuccess } from './actions';
import { EDealType } from '../../types/dealType';
import { fetchPreciseFilters } from '../../api/priceEstimator/fetchPreciseFilters';
import { ECategory } from '../../repositories/price-estimator/v3/get-filters-web/types';

export const getPreciseFilters =
  (category?: ECategory): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    dispatch(getFiltersRequest());

    try {
      const [saleFilters, rentFilters] = await Promise.all([
        fetchPreciseFilters(context, { dealType: EDealType.Sale, category }),
        fetchPreciseFilters(context, { dealType: EDealType.Rent, category }),
      ]);

      dispatch(getFiltersSuccess({ dealType: EDealType.Sale, data: saleFilters }));
      dispatch(getFiltersSuccess({ dealType: EDealType.Rent, data: rentFilters }));
    } catch (e) {
      dispatch(getFiltersFailure());

      return e;
    }
  };
